class EventListener {
  constructor() {
    this.setupListeners();
  }

  setupListeners() {
    // Clique no botão de carrinho
    const icocart = document.querySelector('.icone-carrinho');
    if (icocart) {
      icocart.removeEventListener('click', this.abrirCarrinho);
      icocart.addEventListener('click', this.abrirCarrinho);
    }

    // Clique para adicionar sacolinha de presente
    const addPresente = document.querySelector('.btn-presente');
    if (addPresente) {
      addPresente.removeEventListener('click', this.sacolaPresente);
      addPresente.addEventListener('click', this.sacolaPresente.bind(this)); // Adiciona o bind(this) aqui
    }


    // Clique fora para sair do carrinho
    const carrinho = document.querySelector('.carrinho-ajax');
    if (carrinho) {
      carrinho.removeEventListener('click', this.fecharCarrinho);
      carrinho.addEventListener('click', this.fecharCarrinho);
    }

    // Impede a propagação do click através carrinho-box e carrinho ajax
    const carrinhoBox = document.querySelector(".carrinho-box");
    if (carrinhoBox) {
      carrinhoBox.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }

    // Clique no 'X' para sair do carrinho
    document.querySelectorAll('.fechar-carrinho').forEach((e) => {
      e.removeEventListener('click', this.fecharCarrinho);
      e.addEventListener('click', this.fecharCarrinho);
    });

    // Clique nos botões de atualizar quantidade
    document.querySelectorAll('.carrinho-item-conteudo-esquerda-quantidade button').forEach(btn => {
      btn.removeEventListener('click', this.atualizarQuantidade);
      btn.addEventListener('click', (e) => {
        e.preventDefault(); // Prevenir comportamento padrão
        this.atualizarQuantidade(btn);
      });
    });

    // Clique no ícone de remoção (lixeira) para remover o item do carrinho
    document.querySelectorAll('.remove-item').forEach((element) => {
      element.removeEventListener('click', this.removerItemCarrinho);
      element.addEventListener('click', this.removerItemCarrinho.bind(this));
    });


    // Calculadora de frete
    const collapsibleHeader = document.querySelector('.collapsible-header');
    const freteProduto = document.querySelector('.frete-produto-lateral');
    const arrowIcon = document.querySelector('.arrow-icon');

    if (collapsibleHeader && freteProduto && arrowIcon) {
      collapsibleHeader.removeEventListener('click', this.toggleFreteProduto);
      collapsibleHeader.addEventListener('click', this.toggleFreteProduto.bind(this, freteProduto, arrowIcon));
    }

    // Listeners para o campo de NOMES
    const nomeInput = document.getElementById('nome-input');
    const nomeCounter = document.getElementById('nome-counter');

    if (nomeInput) {
      nomeInput.addEventListener('input', () => {
        const currentLength = nomeInput.value.length;
        nomeCounter.textContent = `${currentLength}/${nomeInput.maxLength}`;

        if (currentLength === nomeInput.maxLength) {
          nomeCounter.classList.add('max-reached');
        } else {
          nomeCounter.classList.remove('max-reached');
        }
      });
    }

    // Listener para quando o valor selecionado no select muda
    document.body.addEventListener('change', (event) => {
      if (event.target.closest('.select__select')) {
        this.verificarSelecao();
      }
    });
  }

  // Icone de remover do carrinho
  async removerItemCarrinho(event) {
    event.preventDefault();

    const spinner = event.currentTarget.querySelector('.loader .loading__spinner');
    spinner.classList.remove('hidden');

    const removeUrl = event.currentTarget.getAttribute('href');

    try {
      const response = await fetch(removeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'text/html',
        },
      });

      const html = await response.text();

      let divtemporaria = document.createElement('div');
      divtemporaria.innerHTML = html;

      let novoCarrinhoBox = divtemporaria.querySelector('.carrinho-box').innerHTML;
      document.querySelector('.carrinho-box').innerHTML = novoCarrinhoBox;

      let novaBolinha = divtemporaria.querySelector('.carrinho-header-contador').innerHTML;
      this.atualizaBolinha(novaBolinha);

      this.setupListeners();

    } catch (error) {
      console.error('Erro ao remover o item:', error);
    } finally {
      spinner.classList.add('hidden');
    }
  }


  // Verificador do campo personalizado para INICIAIS e NOMES
  validarPersonalizacao() {
    const charInput = document.getElementById('char-input');
    const nomeInput = document.getElementById('nome-input');

    if (charInput && charInput.offsetParent !== null) {
      const maxLength = charInput.maxLength;
      const inputLength = charInput.value.length;

      if (inputLength === 0) {
        alert("O campo de personalização está vazio. Por favor, insira as iniciais.");
        return false;
      }

      if (maxLength === 2 && inputLength < 2) {
        alert("O campo de personalização está incompleto. Por favor, insira 2 iniciais.");
        return false;
      }
    }

    if (nomeInput && nomeInput.offsetParent !== null) {
      const maxLength = nomeInput.maxLength;
      const minLength = nomeInput.minLength;
      const inputLength = nomeInput.value.length;

      if (inputLength === 0) {
        alert("O campo de nome completo está vazio. Por favor, insira o nome.");
        return false;
      }

      if (inputLength < minLength) {
        alert(`O campo de nome completo está incompleto. Insira pelo menos ${minLength} caracteres.`);
        return false;
      }

      if (inputLength > maxLength) {
        alert(`O campo de nome completo excedeu o limite de ${maxLength} caracteres.`);
        return false;
      }
    }

    return true;
  }

  // Verificador do upload da Polaroid
  validarPolaroid() {
    const polaroidComponent = document.querySelector('polaroid-upload');
    if (polaroidComponent && typeof polaroidComponent.validate === 'function') {
      return polaroidComponent.validate();
    }
    // Se não existe o componente na página, não bloqueia
    return true;
  }

  // Retorna a URL da imagem da Polaroid (ou string vazia)
  getPolaroidUrl() {
    const polaroidComponent = document.querySelector('polaroid-upload');
    if (polaroidComponent && typeof polaroidComponent.getImageUrl === 'function') {
      return polaroidComponent.getImageUrl();
    }
    return '';
  }

  validarPersonalizacaoCarrossel(formu) {
    const charInput = formu.querySelector('.char-input'); // Pega o input específico do carrossel
    const nomeInput = formu.querySelector('.nome-input'); // Pega o input específico do carrossel

    if (charInput && charInput.offsetParent !== null) {
      const maxLength = charInput.maxLength;
      const inputLength = charInput.value.length;

      if (inputLength === 0) {
        alert("O campo de personalização está vazio. Por favor, insira as iniciais.");
        return false;
      }

      if (maxLength === 2 && inputLength < 2) {
        alert("O campo de personalização está incompleto. Por favor, insira 2 iniciais.");
        return false;
      }
    }

    if (nomeInput && nomeInput.offsetParent !== null) {
      const maxLength = nomeInput.maxLength;
      const minLength = nomeInput.minLength;
      const inputLength = nomeInput.value.length;

      if (inputLength === 0) {
        alert("O campo de nome completo está vazio. Por favor, insira o nome.");
        return false;
      }

      if (inputLength < minLength) {
        alert(`O campo de nome completo está incompleto. Insira pelo menos ${minLength} caracteres.`);
        return false;
      }

      if (inputLength > maxLength) {
        alert(`O campo de nome completo excedeu o limite de ${maxLength} caracteres.`);
        return false;
      }
    }

    return true;
  }


  // Abrir Carrinho
  abrirCarrinho() {
    document.querySelector(".carrinho-ajax").classList.add("ativo");
  }

  // Fechar Carrinho
  fecharCarrinho() {
    document.querySelector(".carrinho-ajax").classList.remove("ativo");
  }

  // Atualizar Quantidade
  async atualizarQuantidade(btn) {
    let quantidade = Number(btn.parentElement.querySelector('input').value);
    let isUp = btn.classList.contains('subir-quantidade');
    const quantidadeNova = isUp ? quantidade + 1 : quantidade - 1;

    if (quantidadeNova < 0) return;

    let variantID = btn.parentElement.querySelector('input').getAttribute('data-variante-id');

    const spinner = btn.closest('.carrinho-item').querySelector('.loader .loading__spinner');
    spinner.classList.remove('hidden');

    btn.parentElement.querySelector('input').value = quantidadeNova;

    await this.apiUpdate(variantID, quantidadeNova);

    spinner.classList.add('hidden');
  }


  // Requisição API para atualizar quantidades do carrinho
  async apiUpdate(variantID, quantidadeNova) {
    let resposta = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: { [variantID]: quantidadeNova },
        sections: "carrinho-ajax"
      })
    });

    resposta = await resposta.json();
    if (resposta.sections) {
      let carrinho = resposta.sections["carrinho-ajax"];
      let divtemporaria = document.createElement('div');
      divtemporaria.innerHTML = carrinho;
      let novoCarrinhoBox = divtemporaria.querySelector('.carrinho-box').innerHTML;
      document.querySelector('.carrinho-box').innerHTML = novoCarrinhoBox;
      let novaBolinha = divtemporaria.querySelector('.carrinho-header-contador').innerHTML;
      this.atualizaBolinha(novaBolinha);
      this.setupListeners();
    }
  }

  // Atualizar bolinha contadora do carrinho
  atualizaBolinha(valor) {
    const contador = document.querySelector('.carrinho-contador');
    if (valor == 0) {
      contador.style.display = "none";
    } else {
      contador.style.display = "flex";
      document.querySelector('.carrinho-contador span').innerHTML = valor;
    }
  }


  // Requisição API para adicionar ao carrinho
  async apiCarrinho(formData) {
    let resposta = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    resposta = await resposta.json();
    if (resposta.sections) {
      let carrinho = resposta.sections["carrinho-ajax"];
      let divtemporaria = document.createElement('div');
      divtemporaria.innerHTML = carrinho;
      let novoCarrinhoBox = divtemporaria.querySelector('.carrinho-box').innerHTML;
      document.querySelector('.carrinho-box').innerHTML = novoCarrinhoBox;
      let novaBolinha = divtemporaria.querySelector('.carrinho-header-contador').innerHTML;
      this.atualizaBolinha(novaBolinha);
      this.setupListeners();
    }
  }

  // Adicionar sacola de presente
  async sacolaPresente() {
    const sacolaWrapper = document.querySelector(".presente-wrapper");
    const idPresente = Number(sacolaWrapper.querySelector(".product-variant-id").value);
    let formData = {
      'items': [{
        'id': idPresente,
        'quantity': 1
      }],
      'sections': "carrinho-ajax"
    };
    await this.apiCarrinho(formData);
  }

  // Função para alternar a visibilidade do frete-produto e a rotação do ícone
  toggleFreteProduto(freteProduto, arrowIcon) {
    if (freteProduto.classList.contains('open')) {
      freteProduto.classList.remove('open');
      arrowIcon.style.transform = 'rotate(0deg)';
    } else {
      freteProduto.classList.add('open');
      arrowIcon.style.transform = 'rotate(90deg)';
    }
  }

  // Verificar seleção de variantes e ajustar o input de NOMES
  verificarSelecao() {
    var selectElement = document.querySelector('.select__select');
    var selectedOption = selectElement.options[selectElement.selectedIndex].text;

    var nomesDiv = document.querySelector('.label-nomes-wrapper');

    if (selectedOption.includes("1 nome + 2 sobrenomes") || selectedOption.includes("2 nomes + 1 sobrenome")) {
      document.getElementById('nome-input').minLength = 5;
      document.getElementById('nome-input').maxLength = 30;
      nomesDiv.style.display = "block";
      document.getElementById('nome-input').required = true;
    } else {
      nomesDiv.style.display = "none";
      document.getElementById('nome-input').required = false;
    }

    document.getElementById('nome-input').value = '';
    document.getElementById('nome-counter').classList.remove('max-reached');
  }
}

// Inicializar o listener
const eventListener = new EventListener();

// Evita botão de add carrinho na página de produto e solicita o nosso AJAX personalizado
let cartProductPage = document.querySelectorAll('form[action="/cart/add"]');
cartProductPage.forEach((formu) => {

  // Garante que o comportamento padrão de submit do formulário seja prevenido
  formu.addEventListener("submit", (evento) => {
    evento.preventDefault(); // Previne o comportamento de redirecionar para o /cart
  });

  // Lida com o clique no botão de adicionar ao carrinho
  formu.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
    button.addEventListener("click", async (evento) => {
      evento.preventDefault(); // Previne o comportamento padrão ao clicar no botão

      const sectionId = formu.querySelector('input[name="section-id"]').value;

      const variantSelectElements = document.querySelectorAll('variant-selects'); // Seleciona elementos de variantes

      // Declara as variáveis charInput e nomeInput fora do bloco condicional
      let charInput;
      let nomeInput;

      // Verifica se há personalizações que precisam ser validadas
      if (variantSelectElements.length < 2) {
        // Se estiver na página de produto
        charInput = document.querySelector('#char-input');
        nomeInput = document.querySelector('#nome-input');

        let valid = true;  // Flag para acompanhar se a validação foi bem-sucedida

        // Verificação do charInput
        if (charInput) {
          if (charInput.offsetParent !== null) {  // O campo está visível
            if (!eventListener.validarPersonalizacao()) {
              valid = false;  // A validação falhou
            }
          }
        }

        // Verificação do nomeInput
        if (nomeInput) {
          if (nomeInput.offsetParent !== null) {  // O campo está visível
            if (!eventListener.validarPersonalizacao()) {
              valid = false;  // A validação falhou
            }
          }
        }

        if (!valid) {
          return;  // Bloqueia a adição ao carrinho se a validação falhar
        }

        // Validação da Polaroid
        if (!eventListener.validarPolaroid()) {
          return; // Bloqueia a adição ao carrinho se a Polaroid não estiver preenchida
        }

      } else {
        // Se houver múltiplas variantes (no carrossel)
        charInput = formu.querySelector('#char-input');
        nomeInput = formu.querySelector('#nome-input');

        if (!eventListener.validarPersonalizacaoCarrossel(formu)) {
          return;  // Bloqueia a adição ao carrinho se a validação falhar
        }
      }

      // Agora, charInput e nomeInput estão disponíveis aqui

      const formuId = formu.getAttribute('id');
      const quantityInput = document.querySelector(`.quantity__input[form="${formuId}"]`).value;

      // Prepara os dados do formulário para envio via AJAX
      let formData = {
        'items': [{
          'id': Number(formu.querySelector('.product-variant-id').value),
          'quantity': Number(quantityInput)
        }],
        'sections': "carrinho-ajax"
      };

      // Verifica e armazena as personalizações (iniciais, nomes, etc.)
      if (charInput && charInput.offsetParent !== null) {
        const iniciais = charInput.value;
        localStorage.setItem('valorPersonalizado', iniciais);
        formData.items[0].properties = {
          'Iniciais': iniciais
        };
      }

      if (nomeInput && nomeInput.offsetParent !== null) {
  const nomes = nomeInput.value;
  localStorage.setItem('valorPersonalizado', nomes);
  formData.items[0].properties = formData.items[0].properties || {};
  formData.items[0].properties['NOMES'] = nomes;
}

      // Verifica se o item é um gift card e se o checkbox foi marcado
      const recipientCheckbox = document.querySelector(`#Recipient-checkbox-${sectionId}`);
      const recipientEmail = document.querySelector(`#Recipient-email-${sectionId}`);
      const recipientName = document.querySelector(`#Recipient-name-${sectionId}`);
      const recipientMessage = document.querySelector(`#Recipient-message-${sectionId}`);
      const recipientSendOn = document.querySelector(`#Recipient-send-on-${sectionId}`);

      if (recipientCheckbox && recipientCheckbox.checked) {
        formData.items[0].properties = formData.items[0].properties || {};

        // Validação do campo de e-mail - obrigatório
        if (!recipientEmail.value) {
          alert("Por favor, insira o e-mail do destinatário.");
          recipientEmail.focus(); // Foca no campo de e-mail para o usuário preencher
          return; // Impede o envio do formulário se o e-mail estiver vazio
        }

        formData.items[0].properties['Recipient email'] = recipientEmail.value;

        // Adiciona opcionalmente os outros campos
        if (recipientName && recipientName.value) {
          formData.items[0].properties['Recipient name'] = recipientName.value;
        }
        if (recipientMessage && recipientMessage.value) {
          formData.items[0].properties['Message'] = recipientMessage.value;
        }
        if (recipientSendOn && recipientSendOn.value) {
          formData.items[0].properties['Send on'] = recipientSendOn.value;
        }

        // Adiciona as propriedades faltantes
        formData.items[0].properties['__shopify_send_gift_card_to_recipient'] = "on"; // Adiciona o flag de envio
        formData.items[0].properties['__shopify_offset'] = "180"; // Define o fuso horário (offset) para GMT-3
      }

      // Adiciona a propriedade da Polaroid (link da imagem via ImgBB)
      const polaroidUrl = eventListener.getPolaroidUrl();
      if (polaroidUrl) {
        formData.items[0].properties = formData.items[0].properties || {};
        formData.items[0].properties['Foto da Polaroid'] = polaroidUrl;
      }

      // Simula a abertura do carrinho após adicionar o item
      setTimeout(function () {
        eventListener.abrirCarrinho();
      }, 500);

      // Faz a requisição via AJAX para adicionar o item ao carrinho
      await eventListener.apiCarrinho(formData);
    });
  });
});





